export default __webpack_public_path__ + "static/media/full-redaction.b912022f.svg";